var map = {
	"./bandeau_CAPC.jpg": "../../navigart-conf/img/branding/bandeau_CAPC.jpg",
	"./bandeau_CAPC_ANC.jpg": "../../navigart-conf/img/branding/bandeau_CAPC_ANC.jpg",
	"./branding.png": "../../navigart-conf/img/branding/branding.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./img/branding sync recursive ^\\.\\/.*$";